import { useContext, useState, useEffect } from "react";
import { remove } from "../../../../adapters/xhr/api";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import styleListData from "./index.module.css";
import stylesModal from "../../forms/formTypes/Modal.module.css";

import Pagination, {
  PaginationTax,
} from "../../../../shared/pagination/Pagination";
import { useParams } from "react-router-dom";
import { getDeclerationUnitList } from "../../../../adapters/apis/lookups/lookups";
import Modal from "react-modal";

const VacantLandsList = ({ onDeleteSuccess }) => {
  Modal.setAppElement("body");

  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    setDeclarationRequest,
    setIsUnitInSameBuilding,
    isFormValidCheckForEditList,
    setBackendError,
  } = unifiedTaxDeclarationContext;

  const { id } = useParams();
  const [limit, setLimit] = useState(
    declarationRequest?.vacant_land?.pagination?.vacant_per_page,
  );
  const [showModal, setShowModal] = useState(false);
  const [idToBeDeleted, setIdToBeDeleted] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // useEffect(() => {
  //   handlePageChange(1);
  // }, []);

  const handlePageChange = async (index, newLimit) => {
    try {
      const param = `vacant_page=${index}&vacant_per_page=${newLimit || limit}`;
      const response = await getDeclerationUnitList(id, param);

      setDeclarationRequest({
        ...declarationRequest,
        vacant_land:
          response?.data?.data?.vacant_land ||
          response?.data?.data?.vacant_land,
      });
    } catch (error) {
      console.log("لا توجد بيانات متاحة");
    }
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    handlePageChange(1, newLimit);
  };

  const handleShowUnit = (unit) => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit,
      isShowOnlyUnit: true,
      isUnitViewMode: true,
    }));
    setIsUnitInSameBuilding(false);
  };

  const handleEditUnit = (unit) => {
    if (isFormValidCheckForEditList()) {
      setDeclarationRequest((prev) => ({
        ...prev,
        unit,
        isUnitEditMode: true,
        isUnitViewMode: false,
        isShowOnlyUnit: true,
      }));
      setIsUnitInSameBuilding(false);
    } else {
      window.scroll(0, 0);
    }
  };

  const handleDeleteUnit = async () => {
    setIsLoading(true);
    setBackendError(null);
    try {
      if (!idToBeDeleted) {
        return;
      }
      const response = await remove(
        `api/declaration-system/declarations/${id}/units/vacant/${idToBeDeleted}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        },
      );
      setDeclarationRequest({
        ...declarationRequest,
        vacant_land:
          response?.data?.data?.vacant_land ||
          response?.data?.data?.vacant_land,
        units_count: response?.data?.data?.units_count,
      });
      setShowModal(false);
      setIdToBeDeleted(null);
      onDeleteSuccess?.();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setBackendError(
        error?.response?.data?.message || "حدث خطأ أثناء حذف الوحدة",
      );
      setShowModal(false);
      window.scroll(0, 0);
    }
  };

  const vacantLands =
    declarationRequest?.vacant_land || declarationRequest?.vacant_land;

  const data = vacantLands?.data?.map((unit) => {
    const districtText =
      unit?.village_id == -1 ? unit?.village_other : unit?.village_text || "";
    const streetText =
      unit?.region_id == -1 ? unit?.region_other : unit?.region_text || "";
    const buildingText =
      unit?.real_estate_id == -1
        ? unit?.real_estate_other
        : unit?.real_estate_code || "";
    const propertyAddress = unit?.full_address;

    const renin =
      unit?.buildingProfile?.renin || unit?.manual_renin || "لم يتم تحديده بعد";

    return (
      <tr key={unit?.id}>
        {/* <td data-label="نوع العقار">
          {unit?.property_type_text || "أراضي فضاء مستغلة"}
        </td> */}
        <td data-label="المحافظة">
          {unit?.buildingProfile?.address?.goveronrate ||
            unit?.governorate_text ||
            unit?.manual_governorate_name ||
            ""}
        </td>

        <td data-label=" عنوان العقار">
          {" "}
          {unit?.correct_astrick_colour && (
            <span className={`${unit.correct_astrick_colour} mr-1`}>*</span>
          )}
          {propertyAddress || ""}
        </td>
        <td data-label="الرقم القومي العقاري للمبنى">
          {unit?.correct_astrick_colour && (
            <span className={`${unit.correct_astrick_colour} mr-1`}>*</span>
          )}
          {renin || "—"}{" "}
        </td>
        <td data-label="مساحة الأرض الكلية">{unit?.total_land_area || ""}</td>
        <td data-label="إجمالي مساحة الأرض المستغلة">
          {unit?.total_used_area || "—"}
        </td>

        {/* actions */}
        <td data-label="تفاصيل">
          <div
            className={`d-flex gap-2 ${styleListData["action-buttons-small-screen"]}`}
          >
            <div className={`${styleListData["action-buttons"]}`}>
              <button
                className={`${styleListData["btn-view"]}`}
                onClick={() => handleShowUnit(unit)}
              >
                <i className="fa-solid fa-file-lines"></i>
              </button>
              {!declarationRequest?.viewMode && (
                <span className={`${styleListData["divider"]}`}></span>
              )}

              {!declarationRequest?.viewMode && (
                <>
                  <button
                    className={`${styleListData["btn-edit"]}`}
                    onClick={() => handleEditUnit(unit)}
                  >
                    <i className="fa-solid fa-pen-to-square"></i>
                  </button>

                  <span className={`${styleListData["divider"]}`}></span>
                  <button
                    className={`${styleListData["btn-delete"]}`}
                    onClick={() => {
                      // check property type id
                      // set name based on id
                      // use state in delete api
                      setIdToBeDeleted(unit?.id);
                      setShowModal(true);
                    }}
                  >
                    <i className="fa-solid fa-trash-can"></i>
                  </button>
                </>
              )}
            </div>
          </div>
        </td>
      </tr>
    );
  });

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>هل أنت متأكد من حذف هذا العقار؟</h5>
          <div className="d-flex gap-4 justify-content-center">
            <button
              className="btn btn-primary px-3"
              onClick={handleDeleteUnit}
              disabled={isLoading}
            >
              نعم
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowModal(false)}
            >
              لا
            </button>
          </div>
        </div>
      </Modal>
      {vacantLands?.data?.length > 0 ? (
        <>
          <div
            className={`${styleListData["table-responsive"]} table-responsive`}
          >
            <table className="table">
              <thead>
                <tr>
                  {/* <th>نوع العقار</th> */}
                  <th>المحافظة</th>
                  <th>عنوان العقار</th>
                  <th>الرقم القومي العقاري للمبنى</th>
                  {/* <th>رقم العقار/المبنى المتعارف عليه</th> */}
                  <th>مساحة الأرض الكلية</th>
                  <th>إجمالي مساحة الأرض المستغلة</th>
                  <th>تفاصيل</th>
                </tr>
              </thead>
              <tbody>
                {data?.length > 0 ? (
                  data
                ) : (
                  <tr>
                    <td colSpan={6} className="h5 text-center">
                      لا يوجد أراضي فضاء مستغلة
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <PaginationTax
            limit={limit}
            count={vacantLands?.pagination?.vacant_total}
            active={vacantLands?.pagination?.vacant_current_page}
            callback={handlePageChange}
            handleLimitChange={handleLimitChange}
          />
        </>
      ) : (
        <h4 className="text-center box-title">لا يوجد أراضي فضاء مستغلة</h4>
      )}
    </>
  );
};
export default VacantLandsList;
